import IKey from '../Interfaces/IKey';

import ReservedValue from './ReservedValue';

const columnBasis = 10;

/**
 * Places an anchor in the center of "column", at the given index.
 *
 * @param columns The total number of columns that the focusable space
 *   should be divided into.
 */

const anchor = (columns: number) => (anchorIndex: number) => {
    const anchorWidth = 100 / columns;
    const midPoint = anchorWidth / 2;

    return anchorWidth * anchorIndex + midPoint;
};

/**
 * Divides the provided basis into n columns (based on `columnBasis`),
 * and places an anchor at the center of each column. Returns an array
 * of all anchors for a focusable element.
 */

const anchors = (basis: number) => {
    const columns = basis / columnBasis;
    const anchorAtColumn = anchor(columns);

    return [...Array(columns)].map((_, index) => anchorAtColumn(index));
};

const toolbarKeys: IKey[] = [
    {key: 0, value: ReservedValue.BACKSPACE, basis: 20, anchors: anchors(20)},
    {key: 1, value: ReservedValue.CLEAR, basis: 40, anchors: anchors(40)},
    {key: 2, value: ReservedValue.SHIFT, basis: 20, anchors: anchors(20)},
    {key: 3, value: ReservedValue.TOGGLE_KEY_SET, basis: 20, anchors: anchors(20)},
];

const shortcutKeys: IKey[] = [
    {key: 0, value: '@gmail.com', basis: 30, anchors: anchors(30)},
    {key: 1, value: '@gmx.de', basis: 30, anchors: anchors(30)},
    {key: 2, value: '.com', basis: 20, anchors: anchors(20)},
    {key: 3, value: '.de', basis: 20, anchors: anchors(20)},
];

const alphanumericKeyset: IKey[] = [
    {key: 0, value: 'a'},
    {key: 1, value: 'b'},
    {key: 2, value: 'c'},
    {key: 3, value: 'd'},
    {key: 4, value: 'e'},
    {key: 5, value: 'f'},
    {key: 6, value: 'g'},
    {key: 7, value: '1'},
    {key: 8, value: '2'},
    {key: 9, value: '3'},
    {key: 10, value: 'h'},
    {key: 11, value: 'i'},
    {key: 12, value: 'j'},
    {key: 13, value: 'k'},
    {key: 14, value: 'l'},
    {key: 15, value: 'm'},
    {key: 16, value: 'n'},
    {key: 17, value: '4'},
    {key: 18, value: '5'},
    {key: 19, value: '6'},
    {key: 20, value: 'o'},
    {key: 21, value: 'p'},
    {key: 22, value: 'q'},
    {key: 23, value: 'r'},
    {key: 24, value: 's'},
    {key: 25, value: 't'},
    {key: 26, value: 'u'},
    {key: 27, value: '7'},
    {key: 28, value: '8'},
    {key: 29, value: '9'},
    {key: 30, value: 'v'},
    {key: 31, value: 'w'},
    {key: 32, value: 'x'},
    {key: 33, value: 'y'},
    {key: 34, value: 'z'},
    {key: 35, value: '-'},
    {key: 36, value: '@'},
    {key: 37, value: '.'},
    {key: 38, value: '0'},
    {key: 39, value: '_'},
];

const specialCharsKeyset: IKey[] = [
    {key: 0, value: ','},
    {key: 1, value: '+'},
    {key: 2, value: '%'},
    {key: 3, value: "'"},
    {key: 4, value: '"'},
    {key: 5, value: '('},
    {key: 6, value: ')'},
    {key: 7, value: ':'},
    {key: 8, value: ';'},
    {key: 9, value: '='},
    {key: 10, value: '&'},
    {key: 11, value: '!'},
    {key: 12, value: '#'},
    {key: 13, value: '£'},
    {key: 14, value: '¥'},
    {key: 15, value: '^'},
    {key: 16, value: '*'},
    {key: 17, value: '['},
    {key: 18, value: ']'},
    {key: 19, value: '{'},
    {key: 20, value: '}'},
    {key: 21, value: '/'},
    {key: 22, value: '€'},
];

export {toolbarKeys, shortcutKeys, alphanumericKeyset, specialCharsKeyset};
